import { MockFactory } from '@tino-frontend/mocks'
import { BillListResponseV3, BillStatus } from '@types'
import { billBaseMock } from '@fixtures/apis/bill/detail-v3/bill-base'
import { lineItemCashinReceivableAggregateMock } from '@fixtures/apis/bill/line-item/aggregate-cash-in-receivable'
import { lineItemInstallment } from '@fixtures/apis/bill/line-item/installment'

export const billListAggregateCashinReceivable =
  new MockFactory<BillListResponseV3>({
    current_bill_id: 'bill-OPEN',
    bills: [
      {
        ...billBaseMock.build(
          {
            ...billBaseMock.source,
            id: 'bill-CLOSED',
            payable: true,
            status: BillStatus.Closed,
            line_item_groups: [
              {
                line_items: [lineItemCashinReceivableAggregateMock.source],
                is_paid: false,
              },
              { line_items: [lineItemInstallment.source], is_paid: false },
            ],
          },
          { mergeArray: false }
        ),
      },
    ],
  })
